import {map} from 'rxjs';
import {toUiMsg$} from '@/ui';
import {utaState$, isActivateLendingAccount$} from './user';
import './gray';
import type {UtaState} from '@/types';

export interface UUtaState {
  type: 'uta-state';
  data: UtaState;
}

export interface ULendingAccountStatus {
  type: 'update-lending-account-status';
  data: {
    isActivateLendingAccount: boolean;
  };
}

export function subscriberUsers() {
  utaState$
    .pipe(map((utaState: UtaState): UUtaState => ({type: 'uta-state', data: utaState})))
    .subscribe((msg) => toUiMsg$.next(msg));

  isActivateLendingAccount$.subscribe((isActivateLendingAccount: boolean) =>
    toUiMsg$.next({type: 'update-lending-account-status', data: {isActivateLendingAccount}})
  );
}
